import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip, ClickAwayListener } from '@mui/material';
import './CampaignMembers.scss';

const truncateName = (name, maxLength = 10) => {
  return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
};

const RelatedAccountsCell = ({ relatedAccounts, vendor,campaignId }) => {
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef(null);

  if (!Array.isArray(relatedAccounts) || relatedAccounts.length === 0) {
    return <span style={{ color: 'gray' }}>No related accounts</span>;
  }

  const displayAccounts = relatedAccounts.slice(0, 2);
  const remainingCount = relatedAccounts.length - 2;

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setOpen(true);
  };

  const handleMouseLeave = () => {
    // Use a longer delay to give user time to move to the tooltip
    timeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 300);
  };

  const handleTooltipMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const handleTooltipMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 200);
  };

  // Prevent click on tooltip links from closing tooltip immediately
  const handleLinkClick = (e) => {
    e.stopPropagation();
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div>
        <Tooltip
          title={
            <div 
              className="related-accounts-tooltip"
              onMouseEnter={handleTooltipMouseEnter}
              onMouseLeave={handleTooltipMouseLeave}
            >
              {relatedAccounts.map((account) => (
                <div key={account.id} className="related-account-item">
                            <Link 
                            to={`/account/${vendor}/${account.id}`}
                             className="related-account-link"
                             state={{
                                headerLinkTexts:"Campaign Members",
                                headerLinkTarget:`/campaign/${campaignId}/members`,
                             }}
                             >
                                {account.name}
                            </Link>
                </div>
              ))}
            </div>
          }
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          placement="bottom-start"
          arrow
          slotProps={{
            popper: {
              sx: { 
                pointerEvents: 'auto',
                zIndex: 1500,
              }
            },
            tooltip: {
              sx: {
                pointerEvents: 'auto',
                '&:hover': {
                  visibility: 'visible',
                  opacity: 1
                }
              }
            }
          }}
        >
          <span 
            className="related-accounts-icon" 
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {displayAccounts.map((account, index) => (
              <span key={account.id} className="inline-account-name">
                <Link 
                  to={`/account/${vendor}/${account.id}`} 
                  className="related-account-link"
                >
                  {index === 1 ? truncateName(account.name) : account.name}
                </Link>
                {index === 0 && relatedAccounts.length > 1 ? ', ' : ''}
              </span>
            ))}
            {remainingCount > 0 && <span> +{remainingCount}</span>}
          </span>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default RelatedAccountsCell;